module.exports = __webpack_public_path__ + "static/banner-texture-new-1-b63698e751ffa3bfc92d46dc743a72d2.png";